<template>
  <div>
    <header>
        <div class="fixed">
            <h2>
                <img src="../assets/app_title.png" alt="memorii">
            </h2>
        </div>
        <h1>
            無料で使える<br>
            美容師のためのカルテ管理アプリ
            <img src="../assets/app_icon.png" alt="memorii">
        </h1>
        <a class="c-btn--primary" v-scroll-to="'#contact'">
        ▼利用について相談（無料）
        </a>
    </header>
    <main id="#main" class="u-mt30">
        <section class="p-firstSection">
            <h2 class="c-level4">
            煩雑な紙カルテを<br>
            <strong>クラウド顧客カルテ</strong>に変えて効率化
            </h2>
            <div class="c-card-default u-hidden">
                <p>
                    memoriiは、煩雑だったカルテ管理/予約をサポートするカルテ管理アプリです。<br>
                    iPhoneがあれば、紙カルテや使いにくい管理システムでお客様を管理する必要はありません。現場の美容師のための使いやすさにこだわったカルテ管理/予約アプリで、お客さまとのコミュニケーションを改善し、予約の最大化に貢献します。
                </p>
                <div class="p-slide">
                    <div>
                        <carousel :perPage="1" :autoplay="true" :paginationEnabled="false" :loop="true">
                            <slide>
                                <img src="/img/lp_carousel_01.jpg">
                            </slide>
                            <slide>
                                <img src="/img/lp_carousel_02.jpg">
                            </slide>
                            <slide>
                                <img src="/img/lp_carousel_03.jpg">
                            </slide>
                        </carousel>
                    </div>
                </div>
            </div>
        </section>
        <section>
            <h2 class="c-level4">
            memoriiでできること
            </h2>
            <div class="c-card-default">
            <ul class="p-canList">
                <li>
                    <h3 class="c-level4 u-mb20">
                        カンタンな<strong>顧客/カルテ管理</strong>
                    </h3>
                    <picture>
                        <img src="../assets/can_karte.png" width="135">
                    </picture>
                    <p>
                        シンプルな顧客/カルテ管理機能。iPhoneで持ち運べて、いつでもチェックできます。<br>
                        また、カルテはクラウドに貯まるので、端末が変わったときにも、IDでログインするだけ。スマホが壊れたり、端末を変えても安心して使えます。
                    </p>
                </li>
                <li>
                    <h3 class="c-level4 u-mb20">
                        <strong>予約機能</strong>も無料で
                    </h3>
                    <picture>
                        <img src="../assets/can_rsv.png" width="135">
                    </picture>
                    <p>
                        予約機能も、ワンタップで。予約の受付がつかえます。<br>
                        たくさん予約ツールがある中で、memoriiは予約機能を無料で提供します。なによりも大事にしたいのは、美容師に寄り添ったサービスを提供することです。
                    </p>
                </li>
                <li>
                    <h3 class="c-level4 u-mb20">
                        大事な<strong>顧客との繋がり</strong>を実現
                    </h3>
                    <picture>
                        <img src="../assets/can_sns.png" width="139">
                    </picture>
                    <p>
                        memoriiでは、お客様のSNS情報を登録できます。<br>
                        これにより、大事な顧客の情報を記録できるとともに、コミュニケーションを円滑にできます。
                    </p>
                </li>
            </ul>
            </div>
            <div class="p-commit">
            <h3 class="c-level4 u-mb20">
                使いやすさへのこだわり
            </h3>
            <p>
                「現場で一番使いやすいツールを作る。」それがmemoriiの哲学です。まだ生まれたてのサービスですが美容師のみなさまの声で改善を続けます。
            </p>
            </div>
        </section>
        <section>
            <h2 class="c-level4">
            料金
            </h2>
            <div class="c-card-default p-priceCard">
            <p class="p-priceCard__price">
                <strong>0</strong>
                <span>円</span>
            </p>
            <p class="p-priceCard__text">
                必要なのはiPhoneだけ<br>
                利用料金は無料のサービスです
            </p>
            </div>
        </section>
        <section class="p-contact" id="contact">
            <h2 class="c-level4">
            利用について相談(無料)
            </h2>
            <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSdCwBgeMa01_T9zwWRsUB2dqvoiZxkk-fcYfWxC-_h-bfBJCg/viewform?embedded=true" width="100%" height="1021" frameborder="0" marginheight="0" marginwidth="0">読み込んでいます…</iframe>
        </section>
    </main>
    <p class="c-text__notice--center u-mt30">
      <router-link tag="a" :to="{ path: '/privacy'}" target="_blank">プライバシーポリシー</router-link>
    </p>
    <Footer />
  </div>
</template>

<script>
import Footer from '@/components/Footer.vue'
import { Mixin } from '@/mixin'
import { Carousel, Slide } from 'vue-carousel'

export default {
  name: 'app',
  components: {
    Footer,
    Carousel,
    Slide
  },
  head: {
    title: function () {
      return {
        inner: 'memorii',
        separator: '|',
        complement: '無料で使える美容師のためのカルテ管理アプリ'
      }
    }
  },
  beforeRouteEnter (route, redirect, next) {
    next(async vm => {
      const promises = []
      vm.$store.commit('SET_LOADING', true)
      await Promise.all(promises).then(function () {
        vm.$store.commit('SET_LOADING', false)
      })
    })
  },
  mixins: [Mixin]
}
</script>

<style lang="scss" scoped>
header {
    background: url(/img/catch_img.jpg) no-repeat center center;
    background-size: cover;
    height: 456px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    margin-bottom: 80px;
    .fixed {
        position: fixed;
        top: 20px;
        left: 20px;
        z-index: 1000;
        h2 {
            img {
                width: 129px;
            }
        }
    }
    h1 {
        text-align: center;
        color: #FFF;
        font-size: 2.0rem;
        font-weight: bold;
        line-height: 1.4em;
        > img {
            width: 150px;
            display: block;
            margin: 60px auto 0;
        }
    }
    .c-btn--primary {
        position: absolute;
        bottom: -30px;
        margin: 0 40px;
        position: absolute;
        left: 0;
        bottom: -30px;
        margin: 0 40px;
        width: calc(100% - 80px);
    }
}
section {
    padding-top: 60px;
    &.p-firstSection {
        padding-top: 0;
    }
}
.c-level4 {
    > strong {
        border-bottom: 6px solid #99D3FB;
    }
}
.p-slide {
    background: #212121;
    box-shadow: 0 30px 40px 0 rgba(0,0,0,0.20);
    border-radius: 28px 28px 0 0;
    width: 194px;
    height: 300px;
    margin: 20px auto -20px;
    padding: 8px 8px 0;
    position: relative;
    &:before {
        content: "";
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        z-index: 2;
    }
    > div {
        background-color: #fff;
        border-radius: 20px 20px 0 0;
        height: 100%;
        overflow: hidden;
        position: relative;
        z-index: 1;
        img {
            width: 100%;
            height: 100%;
        }
    }
}
.p-canList {
    > li {
        padding: 20px 0;
        border-bottom: solid 1px #D4D7DA;
        &:first-child {
            padding-top: 0;
        }
        &:last-child {
            padding-bottom: 0;
            border: none;
        }
        picture {
            display: block;
            text-align: center;
            margin-bottom: 20px;
        }
    }
}
.p-commit {
    background: url(../assets/commit_back.png) no-repeat center center;
    background-size: cover;
    padding: 28px 20px;
    p {
        line-height: 1.8em;
    }
}
.p-priceCard {
    background: #fff url(../assets/price_back.png) no-repeat center 10px;
    background-size: contain;
    &__price {
        background-color: #fff;
        display: flex;
        border: solid 10px #99D3FB;
        border-radius: 50%;
        width: 180px;
        height: 180px;
        margin: 0 auto;
        justify-content: center;
        align-items: center;
        margin-bottom: 10px;
        font-size: 2.8rem;
        > strong {
            font-size: 10.0rem;
            line-height: 1em;
        }
        > span {
            margin-top: 42px;
        }
    }
    &__text {
        text-align: center;
    }
}
.p-contact {
    > p {
        margin: 10px 20px;
        line-height: 1.6em;
    }
}
</style>
